// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EMPTY_ARR: any[] = [];

// TODO replace EMPTY_OBJECT declarations
// export const EMPTY_OBJECT: any = {};

// TODO move NOOP here?
